// extracted by mini-css-extract-plugin
module.exports = {"root":"appbar-start_root__8HElb","bookCover":"appbar-start_bookCover__8MVjF"};